<template>
  <div class="mt-2 w-full">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Plans',

  created () {
    this.fn_HIDE_PROGRESS()
    this.getPlans()
  },

  methods: {
    getPlans () {
      const url = '/subscription_plan?itensPerPage=all'

      this.fn_SHOW_PROGRESS()
      return this.$http
        .get(url, this.$store.getters.getAuthHeader)
        .then((res) => {
          const { value: premiumPrice, id: premiumId } = res.data.data.find((plan) => /^premium$/i.test(plan.name))
          const { value: proPrice } = res.data.data.find((plan) => /^pro$/i.test(plan.name))
          const { value: marketplacePrice } = res.data.data.find((plan) => /^premium agenda available$/i.test(plan.name))

          this.$store.dispatch('setPlan', { premiumPrice, proPrice, premiumId, marketplacePrice })
        })
        .finally(() => {
          this.fn_HIDE_PROGRESS()
        })
    }
  }
}
</script>
